



















































import MenuExpandable from '@/modules/common/layout/components/shared/menu/MenuExpandable.vue'
import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, Watch } from 'vue-property-decorator'
import { MenuItemType } from '@/modules/common/layout/models/types/MenuItem'
import { MenuStore } from '@/modules/common/layout/store/menu.store'
import { isDef } from '@/modules/shared/helpers/utils/utils'


@Component({
  components: {
    MenuExpandable
  }
})
export default class MenuItem extends Vue {
  constructor(
    protected readonly menuStore: MenuStore
  ) {
    super()
  }

  isPanel = !!window.location.href.includes('panel')

  $refs!: {
    menuExpandable: MenuExpandable
  }

  @Prop() id //menu-store's item id
  @Prop() itemData!: MenuItemType
  @Prop() mini!: boolean
  @Prop({ default: false }) dynamicHover: boolean

  //-----Hooks-----------
  mounted() {
    if (!!this.highlightedChild_id && !this.isMiniDrawer_or_forceClose) {
      this.expandSubMenu()
    }
  }

  //-----Watch-----------
  @Watch('isMiniDrawer_or_forceClose')
  routeChange(newValue) {
    //Close all miniMenus
    this.$refs['menuExpandable'].openMiniMenu = false
    //Expand submenu if is not miniDrawer
    if (!!this.highlightedChildId_method() && !newValue) {
      this.expandSubMenu()
    }
  }

  @Watch('highlightedChild_id')
  onChange(newValue) {
    if ((this.isHighlight || !!newValue) && !this.isMiniDrawer_or_forceClose) {
      this.expandSubMenu()
    }
  }

  //-----Computed-----------
  get isMiniDrawer_or_forceClose() {
    return this.menuStore.miniDrawer || this.menuStore.forceClose || true
  }

  get isExpandable(): boolean {
    return this.itemData && 'children' in this.itemData && !!this.itemData.children
  }

  get highlightMenu() {
    return (this.highlightChildInMenuItem !== -1 || this.highlightMenuItem)
  }

  get highlightMenuItem() {
    return this.itemData.id === this.id
  }

  get highlightChildInMenuItem() {
    return this.children.findIndex(child => child.id === this.id)
  }

  get children() {
    if (Array.isArray(this.itemData.children)) {
      return this.itemData.children.filter(isDef)
    }
    return []
  }

  get itemDataPath() {
    if (isDef(this.itemData)) {
      return this.itemData.path || ''
    }

    return ''
  }

  get isHighlight(): boolean {
    if (!!!this.itemData.regex) {
      return false
    }

    return this.pathMatch(this.itemData.regex)
  }

  get highlightedChild_id(): null | string {
    return this.highlightedChildId_method()
  }

  //--------Methods---------------
  expandSubMenu() {
    this.$refs['menuExpandable'].toggleSubMenuItem = true
  }

  subMenuLinkClick(index) {
    this.$emit('change', index)
  }

  pathMatch(regex: string): boolean {
    return !!regex ? !!window.location.pathname.match(new RegExp(regex)) : false
  }

  highlightedChildId_method() {
    return this.children.find(child => this.pathMatch(child.regex))?.id
  }
}
